module.exports = __webpack_public_path__ + "static/img/agreement.c2c2bc4.png";